import { Property } from 'csstype'
import React from 'react'

import theme from 'theme'

// note: this is one place where we reuse the same prop types
interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  backgroundGradient?: Property.BackgroundColor[]
  gradientDirection?: 'to right' | 'to left'
}

const Badge: React.FC<BadgeProps> = ({
  backgroundGradient,
  gradientDirection = 'to right',
  ...rest
}) => (
  <div
    data-test-badge
    css={{
      display: 'inline-grid',
      color: theme.colors.white[0],
      cursor: 'default',
      borderRadius: theme.borderRadius[0],
      letterSpacing: theme.letterSpacing[4],
      lineHeight: 1,
      paddingLeft: theme.space[2],
      paddingRight: theme.space[2],
      paddingTop: theme.space[1],
      paddingBottom: theme.space[1],
      textTransform: 'uppercase',
      fontWeight: theme.fontWeights[1],
      fontSize: theme.fontSizes[0],
      placeItems: 'center',
      background: !backgroundGradient
        ? theme.colors.steel[1]
        : `linear-gradient(${gradientDirection}, ${backgroundGradient.join(
            ', '
          )})`
    }}
    {...rest}
  />
)

export default Badge

export const SmallBadge: React.FC<BadgeProps> = (props) => (
  <Badge
    css={{
      fontSize: 10,
      padding: theme.space[1]
    }}
    {...props}
  />
)

export const RMSubscriptionBadge: React.FC<BadgeProps> = (props) => (
  <Badge backgroundGradient={['#FFA615', '#B22449']} {...props}>
    RM Subscription
  </Badge>
)

export const EnterpriseBadge: React.FC<BadgeProps> = (props) => (
  <Badge backgroundGradient={['#FFA615', '#B22449']} {...props}>
    Enterprise
  </Badge>
)

export const ProBadge: React.FC<BadgeProps> = (props) => (
  <Badge backgroundGradient={['#0F8BCE', '#00458A']} {...props}>
    Pro
  </Badge>
)

export const StarterBadge: React.FC<BadgeProps> = (props) => (
  <Badge
    backgroundGradient={[theme.colors.teal[0], theme.colors.blue[0]]}
    {...props}
  >
    Starter
  </Badge>
)

export const FreeBadge: React.FC<BadgeProps> = (props) => (
  <Badge backgroundGradient={[theme.colors.green[0], '#009580']} {...props}>
    Free
  </Badge>
)

export const UpgradeBadge: React.FC<BadgeProps & { contrast: string }> = ({
  contrast,
  ...rest
}) => (
  <Badge
    backgroundGradient={
      contrast
        ? [theme.colors.white[0], theme.colors.white[0]]
        : [theme.colors.teal[0], theme.colors.blue[0]]
    }
    css={[
      contrast && {
        color: theme.colors.teal[1]
      }
    ]}
    {...rest}
  >
    Upgrade
  </Badge>
)
